import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import {
  ChannelType,
  CommunicationInput,
  ViewType,
} from 'src/app/core/component/email-sender/communication.types';
import {
  formBuilderData,
  ResponseData,
} from 'src/app/helper/interface/response';
import { EmailApiService } from 'src/app/modules/email/service/email-api.service';
import { FormDocComponent } from 'src/app/shared/form/component/form-doc/form-doc.component';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { FormHelperModule } from 'src/app/shared/form/form-hepler.module';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss'],
  standalone: true,
  imports: [CommonModule, FormHelperModule],
})
export class CommunicationComponent {
  @ViewChild('basicForm') basicForm!: FormGeneratorComponent;
  @ViewChild('docForm') docForm!: FormDocComponent;

  channel: ChannelType = 'EMAIL';
  viewType: ViewType = 'VIEW';

  title = '';
  loading = false;
  sentBtnShow = false;

  formData: CommunicationInput = { tempName: '' };
  apiResData: any = {};

  pdfUrl: any;
  onClose: Subject<any> = new Subject();
  API: any;
  FORM_CONFIG: formBuilderData[] = [
    {
      colName: 'subject',
      col_size: '12',
      title: 'Subject',
      type: 'text',
      validator: [{ name: 'required' }],
    },
    {
      colName: 'body',
      col_size: '12',
      title: 'Body',
      type: 'editor',
      validator: [{ name: 'required' }],
    },
  ]; // inject your EMAIL_TEMP_FORM here

  constructor(
    private modalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private emailApi: EmailApiService,
  ) {}

  /** Entry point */
  setInput(data: CommunicationInput) {
    this.formData = { ...data };
    this.channel = data.channel || 'EMAIL';
    this.viewType = data.viewType || 'VIEW';
    this.sentBtnShow = !!data.sentBtnShow;

    this.applyReplaceKeys();

    if (this.channel === 'HTML') {
      this.loadContent(data);
    } else if (this.channel === 'PDF') {
      this.viewType = data.viewType || 'VIEW';
      this.loadPdf(data);
    } else {
      this.generateContent(data);
    }
    this.title = `${this.channel} ${this.viewType}`;
  }

  /** Generate email / message */
  generateContent(data: CommunicationInput) {
    this.loading = true;
    this.emailApi
      .generateEmail(data?.tempName || '', data?.payload?.payload || {})
      .then(
        (res: ResponseData) => (
          (this.apiResData = res.result),
          this.loadFormData(data)
        ),
      )
      .finally(() => (this.loading = false));
  }

  loadFormData(data: CommunicationInput) {
    if (this.viewType == 'SEND') {
      this.formData = { ...this.formData, ...this.apiResData };
      this.basicForm?.setData(this.apiResData);
      this.docForm?.setData(this.apiResData.attachment);
    }
  }

  /** PDF preview */
  loadContent(data: CommunicationInput) {
    this.loading = true;
    this.emailApi
      .generateContent(data.tempName || '', { id: data.id })
      .then((res) => {
        if (this.channel == 'HTML') {
          this.apiResData.htmlContent =
            this.sanitizer.bypassSecurityTrustHtml(res);
        }
      })
      .finally(() => (this.loading = false));
  }
  //email  | sms | Whatsapp
  private pdfObjectUrl?: string;

  loadPdf(data: CommunicationInput): void {
    this.loading = true;

    const isPreview = this.viewType === 'PREVIEW';

    const payload:any = {
      ...data.payload,
      ...(isPreview ? {} : { output: 'pdf' }),
    };
    console.log('loadPdf', data, payload, isPreview);
    const request =
      data.api?.(data.id || payload?.id || payload?.payload?.id, isPreview ? data.payload : payload) ??
      (isPreview
        ? this.emailApi.previewPdf(data.tempName, data.id, data.payload)
        : this.emailApi.generateBlobContent(data.tempName || '', {
            id: data.id,
            ...payload,
          }));

    request
      .then((blob: Blob) => {
        this.setPdfUrl(blob);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private setPdfUrl(blob: Blob): void {
    this.revokePdfUrl();

    this.pdfObjectUrl = URL.createObjectURL(
      new Blob([blob], { type: 'application/pdf' }),
    );

    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.pdfObjectUrl,
    );
  }

  private revokePdfUrl(): void {
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = undefined;
    }
  }

  ngOnDestroy(): void {
    this.revokePdfUrl();
  }

  /** Replace dynamic keys */
  applyReplaceKeys() {
    if (!this.formData.replaceKey) return;

    Object.entries(this.formData.replaceKey).forEach(([k, v]) => {
      if (this.formData.body) {
        this.formData.body = this.formData.body.replaceAll(`{${k}}`, String(v));
      }
      if (this.formData.subject) {
        this.formData.subject = this.formData.subject.replaceAll(
          `{${k}}`,
          String(v),
        );
      }
    });
  }

  onBodyChange(e: any) {
    this.formData.body = e.target.innerHTML;
  }

  /** Send communication */
  send() {
    const payload = {
      ...this.apiResData,
      ...this.basicForm?.apiPayload(),
      attachment: this.docForm?.apiPayload() || [],
    };

    this.loading = true;
    this.emailApi
      .sendEmailByData(payload)
      .then(() => {
        this.close({ sent: true });
      })
      .finally(() => (this.loading = false));
  }

  check() {
    console.log('CHECK', this.apiResData);
  }

  close(data: any = null) {
    this.modalRef.hide();
    this.onClose.next(data);
  }
}
